export const joyRideSteps=[
    {
        title:"Add Trainer, Packages, and Services from here", content:"First, create a trainer.", target:"#joy-add-btn", placement:"right"
    },
    {
        title:"Add Trainer, Packages, and Services from here", content:"First, create a trainer.", target:"#joy-add-trainer", placement:"right"
    },

]

export const followupOnOptionsList = [
  {
    label:"Workout",
    value: "workout"
  },
  {
    label:"In-Body Test",
    value: "inBodyTest"
  },
  {
    label:"Body Measurements",
    value: "bodyMeasurements"
  }
];

export const ADMIN_ROLES = [ "SUPER_GYM_ADMIN", "GYM", "ADMIN" ];

export const getCategoryHierarchy = () => {
  return {
    'Upper Body': [
      'Upper Body - Chest',
      'Upper Body - Upper Back', 
      'Upper Body - Shoulder',
      'Upper Body - Biceps',
      'Upper Body - Triceps'
    ],
    'Core': [
      'Core - Abs',
      'Core - Obliques', 
      'Core - Lower Back'
    ],
    'Lower Body': [
      'Lower Body - Quadriceps',
      'Lower Body - Hamstring',
      'Lower Body - Inner Thigh',
      'Lower Body - Outer Thigh',
      'Lower Body - Glutes',
      'Lower Body - Calf'
    ],
    'Workout': ['Workout']
  };
};

export const getMainCategory = (fullCategory) => {
  if (!fullCategory || fullCategory === 'All Categories') return fullCategory;
  return fullCategory.split(' - ')[0];
};

export const getSubCategory = (fullCategory) => {
  if (!fullCategory || fullCategory === 'All Categories') return '';
  const parts = fullCategory.split(' - ');
  return parts.length > 1 ? parts[1] : '';
};

export const formatCompactCategoryDisplay = (fullCategory) => {
  if (!fullCategory || fullCategory === 'All Categories') return { main: fullCategory, sub: '' };
  
  const main = getMainCategory(fullCategory);
  const sub = getSubCategory(fullCategory);
  
  return { main, sub };
};

export const workoutTypes = [
  "Strength Training",
  "Weight Training",
  "Cardio",
  "Functional Training",
  "Flexibility & Mobility",
  "Rehabilitation & Low-Impact"
];
export const workoutDurations = [
  "10",
  "30",
  "40",
];